import React, { useEffect, useState } from "react";
import CardTable from "../../../components/AdminTable/CardTable";
import Dropdown from "../../../components/AdminDropdown/Dropdown";
import { FaEdit } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { apiKey } from "../../../config/config";
import axios from "axios";
import { toast } from "react-toastify";

function SocialMedia() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const [columns] = useState([
    {
      header: "SN",
      cell: (row) => row.row.index + 1,
    },
    {
      header: "Name",
      accessorKey: "name",
    },
    {
      header: "Link",
      accessorKey: "link",
    },

    {
      header: "Status",
      accessorKey: "status",
      cell: (row) => (
        <input
          type="checkbox"
          className="theme-checkbox"
          checked={row.getValue() === "active"}
          onChange={(e) =>
            handleStatusChange(row.row.original.id, row.getValue())
          }
        ></input>
      ),
    },
    {
      header: "Actions",
      accessorKey: "SN",
      cell: (row) => <Dropdown options={buttonData} id={row.row.original.id} />,
    },
  ]);

  const navigate = useNavigate();

  const buttonData = [
    {
      name: "Edit",
      icon: <FaEdit />,
      func: (id) => {
        navigate("editSocialMedia/" + id);
      },
    },
  ];
  const [data, setData] = useState([]);

  const handleStatusChange = (id, status) => {
    axios
      .put(
        `${apiKey}/api/rms/admin/socialmedia/${id}`,
        {
          status: status === "active" ? "inactive" : "active",
        },
        {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        }
      )
      .then((res) => {
        // Update the local data state to reflect the change
        setData((prevData) =>
          prevData.map((item) =>
            item.id === id
              ? { ...item, status: status === "active" ? "inactive" : "active" }
              : item
          )
        );
        toast.success(
          res.data.message || "Successfully updated social media link"
        );
      })
      .catch((err) => {
        toast.error(
          err.response?.data?.message || "Failed to update social media link"
        );
      });
  };

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/admin/socialmedia`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((response) => {
        setData(response.data);
      })
      .catch((err) => {
        console.error("Error fetching social media data:", err);
      });
  }, [user?.token]);

  return (
    <main>
      <CardTable data={data} columns={columns} heading={"Social Media"} />
    </main>
  );
}

export default SocialMedia;
